import React, { useEffect, useRef } from "react";
import { handleAuthStateChanged, setBot } from "./redux/chatSlice";
import { useDispatch, useSelector } from "react-redux";

import Chat from "./components/Chat";
import FeedbackDialog from "./components/FeedbackDialog";
import Input from "./components/Input";
import MenuDrawer from "./components/MenuDrawer";
import TopMenu from "./components/TopMenu";
import { bots } from "./utils/Bots";
import { useLocation } from "react-router-dom";

function App() {
  const dispatch = useDispatch();
  const darkMode = useSelector((state) => state.chat.darkMode);
  const currentBot = useSelector((state) => state.chat.bot);
  const location = useLocation();

  // prevent ES lint warnings from accessing values not in dependency array
  const currentBotIdRef = useRef(currentBot.id);
  const dispatchRef = useRef(dispatch);

  useEffect(() => {
    document.documentElement.setAttribute(
      "data-theme",
      darkMode ? "dark" : "light"
    );
  }, [darkMode]);

  // set bot from query params
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const botParam = params.get("bot");

    if (
      botParam &&
      bots[botParam] &&
      bots[botParam].id !== currentBotIdRef.current
    ) {
      dispatchRef.current(setBot(bots[botParam]));
    }
  }, [location.search]);

  const setComponentHeights = () => {
    const topMenuHeight =
      document.querySelector(".top-menu")?.offsetHeight || 0;
    const inputHeight = document.querySelector(".input")?.offsetHeight || 0;

    document.documentElement.style.setProperty(
      "--app-height",
      `${window.innerHeight}px`
    );
    document.documentElement.style.setProperty(
      "--top-menu-height",
      `${topMenuHeight}px`
    );
    document.documentElement.style.setProperty(
      "--input-height",
      `${inputHeight}px`
    );
  };

  window.addEventListener("resize", setComponentHeights);
  window.addEventListener("orientationchange", setComponentHeights);
  window.addEventListener("load", setComponentHeights);
  setComponentHeights();

  // Handle user on app load
  useEffect(() => {
    dispatch(handleAuthStateChanged());
  }, [dispatch]);

  return (
    <div className="app">
      <TopMenu />
      <Chat />
      <Input />
      <MenuDrawer />
      <FeedbackDialog />
    </div>
  );
}

export default App;
